/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(function() {
	'use strict';
	class Schematic {
		get config(){
			return {
				'customVis': {
					'isSchematic': true,
					'disablePan': true,
					'isRecommendable': false,
					'doesNotSupportCustomGroupAction': true,
					'renderWithoutCompletingMapping':true,
					'cursor': ['grab', '-moz-grab', '-webkit-grab'],
					'thumbnail': {
						'enabled': false,
						'type': 'img'
					},
					'listenForPropChanges': [
						'schematic',
						'views.hidden',
						'showPreview',
						'region.visible',
						'point.visible'
					],
					'dataRowLimit': 30000,
					'dataRowLimitIE': 3000,
					'slots': {
						'locations': {
							'subtype': 'location',
							'icon': 'location'
						},
						'locationColor': {
							'icon': 'heat_map'
						},
						'pointLocations': {
							'icon': 'location',
							'subtype': 'location'
						},
						'pointSize': {
							'icon': 'size_by',
							'multiMeasure':true
						},
						'pointColor': {
							'icon': 'point_heat',
							'tags':[
								'ca.dashboard.repeatHere=true'
							]
						}
					},
					'propertiesToSetBeforeData': [
						'widget.data.truncate'
					],
					'groupedProperty': {
						'widget.legend.color': ['widget.legend.titleColor'],
						'widget.legend.font': ['widget.legend.titleFont']
					},
					'propertyPrefixes': {
						'locationColor': 'widget.legend',
						'pointColor': 'widget.legend',
						'pointSize': 'widget.legend'
					},
					'properties':{
						'widget.data.truncate': {
							active: false,
							defaultValue: true
						},
						'debug.mode': {
							active: false,
							defaultValue: false
						},
						'schematicLibrary': {
							active: false
						},
						'backgroundColor': {
							active: false
						},
						'showPreview': {
							active: false
						},
						'region.visible': {
							active: false
						},
						'point.visible': {
							active: false
						},
						'widget.legend.color':{
							'colorClass': true,
							'addButton': true,
							'displayPos': 45
						},
						'widget.legend.titleColor': {
							'colorClass': true,
							'active': true
						}
					},
					'supportsLayers': true,
					'layerDescriptions':[
						{
							id: 'data.region',
							colorRelatedProps: {
								transparencyProp: 'region.transparency',
								defaultPaletteValue: 'colorPalette0',
								sectionNameId: 'sectionName_regionLayer'
							},
							visibleLayerProps: [
								'region.visible',
								'region.transparency'
							]
						},
						{
							id: 'data.point',
							colorRelatedProps: {
								transparencyProp: 'point.transparency',
								defaultPaletteValue: 'colorPalette1',
								sectionNameId: 'sectionName_pointLayer'
							},
							visibleLayerProps: [
								'point.visible',
								'point.transparency'
							]
						}
					],
					'supportsMaintainAxisScale': true,
					'ignoreElementColor': true,
					'isMultilayersWidget': true,
					'config': {
						'include': [
							'widget.data.truncate',
							'widget.iterator',
							'debug.mode',
							'point.visible',
							'region.visible',
							'showPreview',
							'optimizeSize',
							'backgroundColor',
							'widget.legend.backgroundColor',
							'schematicLibrary',
							'schematic',
							'zoomView',
							'zoomData',
							'viewTransparency',
							'enableViewControl',
							'enableLayerControl',
							'region.transparency',
							'point.transparency',
							'point.defaultSize',
							'point.sizeScaling',
							'point.minSize',
							'point.maxSize',
							'point.staticZeroValueSize',
							'point.autoScaleFactor',
							'widget.legend.display',
							'widget.legend.position',
							'widget.legend.size',
							'locationColor.title',
							'pointColor.title',
							'pointSize.title',
							'widget.legend.titleVisible',
							'widget.legend.titleColor',
							'widget.legend.font',
							'widget.legend.color',
							'widget.legend.swatch.symbol.default',
							'colors.location.cat',
							'colors.location.cont',
							'colors.point.cat',
							'colors.point.cont',
							'widget.legend.splitter',
							'widget.legend.titleFont',
							'widget.legend.fontSize',
							'views.hidden',
							'pagination.control.visible'
						]
					}
				}
			};
		}
	}
	return Schematic;
});
